<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="线路名称" prop="lineName">
            <el-input
              clearable
              v-model="formData.lineName"
              placeholder="请输入线路名称"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="线路类型" prop="lineType">
            <br />
            <el-radio label="R" v-model="formData.lineType">收货线路</el-radio>
            <el-radio label="D" v-model="formData.lineType">送货线路</el-radio>
            <el-radio label="Z" v-model="formData.lineType">不指定</el-radio>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="承运商" prop="carrierCode">
            <dict-select
              filterable
              v-model="formData.carrierCode"
              url="/master/carrier/info/select"
              placeholder="请选择承运商"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="承运商合同" prop="contractCarrierCode">
            <dict-select
              filterable
              clearable
              style="width: 100%"
              v-model="formData.contractCarrierCode"
              placeholder="请选择承运商合同"
              url="/contract/carrier/select"
            >
            </dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="组织机构">
            <org-cascader
              filterable
              :valueString.sync="formData.orgCodeList"
              :props="{ multiple: true }"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
          <el-form-item label="有效状态" prop="lineStatus">
            <br />
            <el-radio label="Y" v-model="formData.lineStatus">已审核</el-radio>
            <el-radio label="N" v-model="formData.lineStatus">新增</el-radio>
            <el-radio label="D" v-model="formData.lineStatus">删除</el-radio>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 24 }">
          <el-form-item label="可用日期类型" prop="useDayType">
            <br />
            <el-radio label="W" v-model="formData.useDayType">按周</el-radio>
            <el-radio label="D" v-model="formData.useDayType">按日</el-radio>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="formData.useDayType === 'W'" :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 24 }">
          <el-checkbox-group v-model="formData.useDaySet">
            <el-checkbox label="1">周一</el-checkbox>
            <el-checkbox label="2">周二</el-checkbox>
            <el-checkbox label="3">周三</el-checkbox>
            <el-checkbox label="4">周四</el-checkbox>
            <el-checkbox label="5">周五</el-checkbox>
            <el-checkbox label="6">周六</el-checkbox>
            <el-checkbox label="7">周日</el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>

      <el-row v-if="formData.useDayType === 'D'" :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 24 }">
          <el-checkbox-group v-model="formData.useDaySet">
            <el-checkbox v-for="index in days" :label="index" :key="index">{{
              index
            }}</el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }">
          <el-form-item label="线路说明" prop="lineDesc">
            <el-input
              clearable
              type="textarea"
              rows="3"
              v-model="formData.lineDesc"
              placeholder="请输入线路说明"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button type="primary" size="small" @click="save()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    code: String,
  },
  components: {},
  data() {
    return {
      backDialogVisible: false,
      formData: {
        lineType: 'Z',
        lineStatus: 'N',
        useDaySet: [],
      },

      rules: {
        lineName: [
          { required: true, message: '请输入线路名称', trigger: 'blur' },
        ],
        lineType: [
          { required: true, message: '请选择线路类型', trigger: 'change' },
        ],
        carrierCode: [
          { required: true, message: '请选择承运商', trigger: 'change' },
        ],
        contractCarrierCode: [
          { required: true, message: '请选择承运商合同', trigger: 'change' },
        ],
        useDayType: [
          { required: true, message: '请选择可用日期类型', trigger: 'change' },
        ],
        useDaySet: [
          { required: true, message: '请选择可用日期', trigger: 'change' },
        ],
        lineStatus: [
          { required: true, message: '请选择有效状态', trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    days() {
      return Array.from({ length: 31 }).map((v, i) => i + 1)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.code) return
      this.$api
        .contractLineDetailApi({
          lineCode: this.code,
        })
        .then((res) => {
          this.formData = res.body
          this.formData.useDaySet = JSON.parse(this.formData.useDaySet)
          
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) {
        this.backDialogVisible = false
        return
      }
      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .contractLineSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
